import { Fragment, useEffect, useState, useRef } from 'react';
import plug from '../../../../assets/plug.png';
import chargerIcon from '../../../../assets/charger-icon.png';
import powerIcon from '../../../../assets/power-icon.png';
import timeIcon from '../../../../assets/time-icon.png';
import checkIcon from '../../../../assets/check-icon.png';
import alertIcon from '../../../../assets/alert-icon.png';
import calenderIcon from '../../../../assets/calender-icon.png';
import './ChargerStatus.css';
import { ChargerStatusResponse, Connectors, FileResponse } from './types';
import { Footer } from './components/Footer/Footer';
import moment from 'moment';
import api from '../../../../axios/axiosConfig';
import { useParams } from 'react-router-dom';
import { HeaderViewer } from '../../../../components/header-viewer/HeaderViewer';
import Modal from '../../../../components/modal/Modal';
import { FleetNotFoundComponent } from '../../page/components/FleetNotFound';

export const ChargerStatus = () => {
  const [isDataReady, setIsDataReady] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [connectors, setConnectors] = useState<ChargerStatusResponse>();
  const [background, setBackground] = useState<string>('');
  const [logo, setLogo] = useState<string>('');
  const [winWidth, setWinWidth] = useState<number>(window.innerWidth);
  const currentDate = moment().format('DD/MM/YYYY - HH:mm');
  const intervalValetQueueTimerRef = useRef<NodeJS.Timeout | number>();
  const [titleDialogModal, setTitleDialogModal] = useState<string>('');
  const [textDialogModal, setTextDialogModal] = useState<string>('');
  const [showDialogModal, setShowDialogModal] = useState<boolean>(false);
  const [isDenied, setIsDenied] = useState<boolean>(false);

  const { id } = useParams();

  const timeInterval = 30 * 1000;

  const getConnectorsStatusBySite = async () => {
    try {
      const response = await api.get<ChargerStatusResponse>(
        `/viewer/SiteConnectorsStatus/${String(id)}`
      );
      if (response.data) {
        setConnectors(response.data);
      }
      return response;
    } catch (err: any) {
      if (err.response.status === 403) {
        setIsDenied(true);
        clearInterval(intervalValetQueueTimerRef.current);
      } else {
        setTitleDialogModal('Erro');
        setTextDialogModal('Ocorreu um erro de comunicação com o servidor.');
        setShowDialogModal(true);
      }
      console.log(err);
    }
  };

  const getFile = async (fileId: string) => {
    try {
      const response = await api.get<FileResponse>(`/Files/${String(fileId)}`);
      if (response.data) {
        setLogo(response.data.fileData);
      }
      return response;
    } catch (err) {
      console.log(err);
    }
  };
  const getFileBg = async (fileId: string) => {
    try {
      const response = await api.get<FileResponse>(`/Files/${String(fileId)}`);
      if (response.data) {
        setBackground(response.data.fileData);
      }
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  const updateWinWidth = () => {
    setWinWidth(window.innerWidth);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    let isVisible = !document.hidden;

    const startPolling = () => {
      if (interval) clearInterval(interval);
      getConnectorsStatusBySite();
      interval = setInterval(getConnectorsStatusBySite, timeInterval);
    };

    const stopPolling = () => {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    };

    const handleVisibilityChange = () => {
      isVisible = !document.hidden;
      if (isVisible) {
        console.log('Página visível - retomando polling (viewer)');
        startPolling();
      } else {
        console.log('Página oculta - pausando polling (viewer)');
        stopPolling();
      }
    };

    // Inicia polling se página está visível
    if (isVisible) {
      startPolling();
    }

    // Listener para mudanças de visibilidade
    document.addEventListener('visibilitychange', handleVisibilityChange);

    const HandleUpdateWinWidth = () => {
      updateWinWidth();
    };
    window.addEventListener('resize', HandleUpdateWinWidth);

    return () => {
      stopPolling();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('resize', HandleUpdateWinWidth);
    };
  }, []);

  useEffect(() => {
    if (connectors?.csLogoFileId) {
      getFile(connectors.csLogoFileId);
    }
    if (connectors?.csBgFileId) {
      getFileBg(connectors.csBgFileId);
    }
  }, [connectors]);

  useEffect(() => {
    intervalValetQueueTimerRef.current = setInterval(() => {
      if (connectors) {
        setIsDataReady(true);
        setIsFetching(false);
        clearInterval(intervalValetQueueTimerRef.current);
      }
    }, 100);

    return () => {
      if (intervalValetQueueTimerRef.current !== null) {
        clearInterval(intervalValetQueueTimerRef.current);
      }
    };
  }, [connectors]);

  if (isDenied) {
    return (
      <FleetNotFoundComponent
        messageError='Falha ao Carregar Dados'
        title={`Não foi possível buscar as informações para o ID  "${id}".`}
        subtitle='Verifique se o ID está correto ou se a requisição está falhando.'
      />
    );
  }

  return (
    <>
      <div style={{ padding: '0px 16px' }}>
        <div className='cs-charger-status'>
          <HeaderViewer
            logo={logo}
            background={background}
            bgColor={connectors?.csBgColor}
          />
          {isFetching && !isDataReady ? (
            <div className='cs-carregando'>
              <span>Carregando...</span>
            </div>
          ) : (
            <Fragment>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className='cs-wrapper-date'>
                  <img
                    src={calenderIcon}
                    alt={`${calenderIcon}`}
                    className='cs-calender-icon'
                  />
                  <span>{currentDate}</span>
                </div>
                <a
                  href={`/spott/valet/${String(id)}`}
                  style={{ textDecoration: 'none', marginTop: '16px' }}
                >
                  <button className='go-to-chargers-button'>
                    Ir para o Valet
                  </button>
                </a>
              </div>
              <div className='cs-header-charger-status'>
                <img src={plug} alt={`${plug}`} className='cs-plug-image' />
                <p className='cs-local-title'>{connectors?.csName}</p>
              </div>
              <div className='cs-chargers-wrapper'>
                <div className='cs-chargers-header'>
                  <span className='cs-chargers-header-title'>
                    Status dos carregadores
                  </span>
                  <div className='cs-total-chargers-wrapper'>
                    <span className='cs-total-chargers-text'>
                      Total de carregadores
                    </span>
                    <span className='cs-total-number-of-chargers'>
                      {connectors?.count}
                    </span>
                  </div>
                </div>
                <div className='cs-gradient' />
                <div className='cs-table-container'>
                  <table className='cs-table'>
                    <thead className='cs-table-head'>
                      <tr className='cs-table-head-tr'>
                        <th className='cs-table-head-th cs-table-head-charger-th'>
                          <div className='cs-th-single'>
                            <img
                              src={chargerIcon}
                              alt={`${chargerIcon}`}
                              className='cs-table-icon'
                            />
                            <span>Carregador</span>
                          </div>
                        </th>
                        <th
                          className='cs-table-head-th'
                          style={{ display: 'flex', justifyContent: 'right' }}
                        >
                          <div className='cs-th-single-power'>
                            <img
                              src={powerIcon}
                              alt={`${powerIcon}`}
                              className='cs-table-icon'
                            />
                            <span>{winWidth <= 480 ? '' : 'Energia'}</span>
                          </div>
                        </th>
                        <th
                          className='cs-table-head-th'
                          style={{ display: 'flex', justifyContent: 'right' }}
                        >
                          <div className='cs-th-single-duration'>
                            <img
                              src={timeIcon}
                              alt={`${timeIcon}`}
                              className='cs-table-icon'
                            />
                            <span>{winWidth <= 480 ? '' : 'Restante'}</span>
                          </div>
                        </th>
                        <th className='cs-table-head-th'>
                          <div className='cs-th-single-status'>
                            <img
                              src={checkIcon}
                              alt={`${checkIcon}`}
                              className='cs-table-icon'
                            />
                            <span>Status</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className='cs-table-body'>
                      {connectors?.connectors?.map(
                        (connector: Connectors, i) => {
                          const duration = connector.requiredChargeTime;
                          const formattedDuration = duration
                            ? duration.substring(0, 5)
                            : '-';

                          //const elapsed = connector.duration;
                          //const formatedElapsed = elapsed ? elapsed && elapsed.substring(0, 5) : '-';
                          const brazilianTime = moment(connector.startTime)
                            .utcOffset(-3)
                            .format('HH:mm');
                          return (
                            <tr key={i} className='cs-charger-info-tr'>
                              <td>
                                <div className='cs-charger-info'>
                                  <span className='cs-charger-name'>
                                    {connector.name}
                                  </span>
                                  <span className='cs-cp-code'>
                                    {connector.uvName
                                      ? `${
                                          connector.uvName
                                        } (${connector.soC?.toFixed(0)} %)`
                                      : `${connector.cpCode}-${connector.connectorId}`}
                                  </span>
                                </div>
                              </td>
                              <td
                                style={{
                                  whiteSpace: 'nowrap',
                                  display: 'flex',
                                  justifyContent: 'right',
                                }}
                              >
                                {connector.transactionId && (
                                  <div
                                    className='cs-power-info'
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    <span
                                      style={{ whiteSpace: 'nowrap' }}
                                      className='cs-power-kWh'
                                    >
                                      {connector.meterKWH?.toFixed(1)} kWh
                                    </span>
                                    <span
                                      style={{ whiteSpace: 'nowrap' }}
                                      className='cs-power-kW'
                                    >
                                      {connector.chargeRateKW.toFixed(1)} kW
                                    </span>
                                  </div>
                                )}
                              </td>
                              <td
                                style={{
                                  whiteSpace: 'nowrap',
                                  display: 'flex',
                                  justifyContent: 'right',
                                }}
                              >
                                {connector.transactionId && (
                                  <div className='cs-duration-info'>
                                    <span
                                      className='cs-charge-duration'
                                      style={{ whiteSpace: 'nowrap' }}
                                    >
                                      {formattedDuration}
                                    </span>
                                    <span
                                      className='cs-charging-time'
                                      style={{ whiteSpace: 'nowrap' }}
                                    >
                                      {brazilianTime}
                                    </span>
                                  </div>
                                )}
                              </td>
                              <td className='cs-charger-status-container-main'>
                                <div className='cs-charger-status-container'>
                                  <div
                                    className='cs-chager-status-wrapper'
                                    style={{
                                      backgroundColor:
                                        connector.cpStatus === 'Offline' &&
                                        (connector.connectorStatus === null ||
                                          connector.connectorStatus ===
                                            'Available')
                                          ? '#EBEEED'
                                          : connector.connectorStatus ===
                                            'Charging'
                                          ? '#CEDCE9'
                                          : connector.connectorStatus ===
                                            'Available'
                                          ? '#93E22E'
                                          : connector.connectorStatus ===
                                            'Preparing'
                                          ? '#CEDCE9'
                                          : connector.connectorStatus ===
                                            'Finishing'
                                          ? '#EF6D44'
                                          : connector.connectorStatus ===
                                            'SuspendedEV'
                                          ? '#FEE7E2'
                                          : connector.connectorStatus ===
                                            'Faulted'
                                          ? '#EBEEED'
                                          : connector.connectorStatus,
                                    }}
                                  >
                                    <span
                                      className='cs-charger-status-span'
                                      style={{
                                        color:
                                          connector.cpStatus === 'Offline' &&
                                          (connector.connectorStatus === null ||
                                            connector.connectorStatus ===
                                              'Available')
                                            ? '#AAB2AF'
                                            : connector.connectorStatus ===
                                              'Charging'
                                            ? '#2688E2'
                                            : connector.connectorStatus ===
                                              'Available'
                                            ? '#196912'
                                            : connector.connectorStatus ===
                                              'Preparing'
                                            ? '#2688E2'
                                            : connector.connectorStatus ===
                                              'Finishing'
                                            ? '#FFFFFF'
                                            : connector.connectorStatus ===
                                              'SuspendedEV'
                                            ? '#B9381C'
                                            : connector.connectorStatus ===
                                              'Faulted'
                                            ? '#AAB2AF'
                                            : connector.connectorStatus,
                                      }}
                                    >
                                      {connector.cpStatus === 'Offline' &&
                                      (connector.connectorStatus === null ||
                                        connector.connectorStatus ===
                                          'Available')
                                        ? 'Desconectado'
                                        : connector.connectorStatus ===
                                          'Charging'
                                        ? 'Carregando'
                                        : connector.connectorStatus ===
                                          'Available'
                                        ? 'Disponível'
                                        : connector.connectorStatus ===
                                          'Preparing'
                                        ? 'Preparando'
                                        : connector.connectorStatus ===
                                          'Finishing'
                                        ? 'Finalizado'
                                        : connector.connectorStatus ===
                                          'SuspendedEV'
                                        ? 'Finalizando'
                                        : connector.connectorStatus ===
                                          'Faulted'
                                        ? 'Falha'
                                        : connector.connectorStatus}
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='cs-footer'>
                <img
                  src={alertIcon}
                  alt={`${alertIcon}`}
                  className='cs-table-icon'
                />
                <div>
                  <span>
                    <strong>Problemas com o carregador, </strong>
                    Suporte por e-mail{' '}
                    <a
                      style={{ color: 'green' }}
                      href='mailto:suporte@spott.eco'
                    >
                      suporte@spott.eco
                    </a>
                    <strong> ou por</strong>{' '}
                    <a
                      style={{ color: 'green' }}
                      href='https://wa.me/5511975568167'
                    >
                      WhatsApp
                    </a>{' '}
                    - (11) 97556-8167
                  </span>
                </div>
                <Footer />
              </div>
            </Fragment>
          )}
        </div>
      </div>
      <Modal
        allowButtonClosed={false}
        isOpen={showDialogModal}
        onClose={() => setShowDialogModal(false)}
        title={titleDialogModal}
        styleEnterButton={{
          backgroundColor: 'rgb(173, 173, 173)',
          border: 'none',
        }}
        textEnterButton='Fechar'
        handleEnterButton={() => setShowDialogModal(false)}
        isLoadingEnterButton={false}
      >
        <p>{textDialogModal}</p>
      </Modal>
    </>
  );
};
